// OButton
export const ButtonSizes = Object.freeze({
  medium: 'md',
  small: 'sm'
})

export const ButtonTypes = Object.freeze({
  solid: 'solid',
  border: 'border',
  link: 'link'
})

export const ButtonVariants = Object.freeze({
  primary: 'primary',
  secondary: 'secondary',
  success: 'success',
  info: 'info',
  danger: 'danger',
  dark: 'dark',
  gray: 'gray',
  ghost: 'ghost',
  white: 'white',
  gold: 'gold',
  green: 'green',
  darkGreen: 'dark-green',
  faded: 'faded',
  fadedBlack: 'faded-black',
  error: 'error'
})

// OTag
export const TagVariants = Object.freeze({
  primary: 'primary',
  secondary: 'secondary',
  success: 'success',
  info: 'info',
  danger: 'danger',
  white: 'white'
})

// OToaster
export const ToasterVariants = Object.freeze({
  success: 'success',
  info: 'info',
  warning: 'warning',
  danger: 'danger'
})
